import React, { FC, ReactElement, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LockOutlined, ReloadOutlined, SyncOutlined } from "@ant-design/icons";
import { useHistory, useParams } from "react-router-dom";
import { Alert, Card, Form, Typography, Button, Space } from "antd";

import { selectErrorMessage, selectErrors, selectUserAuthEmail } from "../../redux-toolkit/auth/auth-selector";
import { resetAuthState } from "../../redux-toolkit/auth/auth-slice";
import { fetchResetPasswordCode, resetPassword } from "../../redux-toolkit/auth/auth-thunks";

const { Title } = Typography;

const ResetPassword: FC = (): ReactElement => {
    const dispatch = useDispatch();
    const params = useParams<{ code: string }>();
    const history = useHistory();
    const userEmail = useSelector(selectUserAuthEmail);
    const errorMessage = useSelector(selectErrorMessage);
    const resetPasswordErrors = useSelector(selectErrors);
    const { passwordError, password2Error } = resetPasswordErrors;

    useEffect(() => {
        dispatch(resetAuthState());
        if (params.code) {
            dispatch(fetchResetPasswordCode(params.code));
        }
    }, []);

    const onClickReset = (data: { password: string; password2: string }) => {
        const userResetPasswordData = { email: userEmail, ...data };
        dispatch(resetPassword({ request: userResetPasswordData, history }));
    };

    return (
        <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
            <Card style={{ width: "100%", maxWidth: 420, borderRadius: 12, padding: "10px 5px" }}>
                <Title level={3} style={{ textAlign: "center", marginBottom: 10 }}>
                    <SyncOutlined /> Reset Password
                </Title>

                {errorMessage && (
                    <Alert type="error" message={errorMessage} style={{ marginBottom: 12 }} />
                )}

                <Form layout="vertical" onFinish={onClickReset}>
                    <Form.Item
                        name="password"
                        label="Password"
                        validateStatus={passwordError ? "error" : ""}
                        help={passwordError}
                        rules={[{ required: true, message: "Please enter your password" }]}
                    >
                        <input
                            type="password"
                            placeholder="Password"
                            className="ant-input"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password2"
                        label="Confirm Password"
                        validateStatus={password2Error ? "error" : ""}
                        help={password2Error}
                        rules={[{ required: true, message: "Please confirm password" }]}
                    >
                        <input
                            type="password"
                            placeholder="Confirm Password"
                            className="ant-input"
                        />
                    </Form.Item>

                    <Space direction="vertical" style={{ width: "100%", marginTop: 10 }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            icon={<ReloadOutlined />}
                            size="large"
                            style={{ borderRadius: 8 }}
                        >
                            Reset Password
                        </Button>
                    </Space>
                </Form>
            </Card>
        </div>
    );
};

export default ResetPassword;
